module.exports = __webpack_public_path__ + "img/Home 2.bddd4dbb.webp";